import React from 'react';

import Tabs from 'muicss/lib/react/tabs';
import Tab from 'muicss/lib/react/tab';

import {A} from 'views/AppElements';
import {useFeaturedProducts, useDesignerProducts} from 'hooks/ProductHook';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import ProductList from 'views/product/ProductList';

import {Separator} from 'views/AppElements';
import UserAvatar from 'views/user/UserAvatar';
import {userDesignerInfo} from 'hooks/UserHook';

import ProductTabs from 'views/product/ProductTabsByType';

import AppConstants from 'AppConstants';
import Loader from 'views/Loader';
import SessionStore from 'stores/SessionStore';
import AppUtil from 'AppUtil';


const ARTWORK_TYPES = AppConstants.ARTWORK_TYPES;

const DesignerHeader = ({user, productImages}) => {
	const radialBg = 'radial-gradient(circle at 100%, rgba(228, 228, 228, 0.32) 72%, rgb(68, 67, 66) 137%)';
	const bgImage = productImages? {backgroundImage: radialBg+", url("+productImages[0]+")"}: {};
	return (
		<div id="designerPageHeader">
			<div id="designerBg" style={bgImage}></div>
			<div className="designerAvatar flexColumn">
				<UserAvatar user={user} />
			</div>
		</div>);
		
}

const DesignerInfo = ({user}) => {
	const currentSession = SessionStore.getCurrentSession();
	const isCurrentUser = currentSession && user && currentSession.user.id === user.id;

	const isCurrentAdmin = AppUtil.isAdminUser(currentSession? currentSession.user: null);
	const isAdmin = AppUtil.isAdminUser(user);

	let editUrl = null;
	if(isCurrentAdmin && !isAdmin && user !== null) editUrl = "/"+user.id+"/settings";
	else editUrl = "/settings";


	const editIcon = (isCurrentUser || isCurrentAdmin)? <A href={editUrl} id="userEditIcon"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></A>: null;
	const dashboardIcon = (user !== null && isCurrentAdmin)? <a href={"/designer/"+user.id+"/dashboard"} id="userDashboardIcon"><i className="fa fa-dashboard" aria-hidden="true"></i></a>: null;

	let designerName = null;
	let userBio = null;

	if(user) {
		let about = user.about;
		if(!about && isCurrentUser)
			about = <A href="/settings">Add Bio</A>;

		designerName = <h2 className="userTitle">{user.username.toUpperCase()} {editIcon} {dashboardIcon}</h2>
		userBio = <span className="userBio">{about}</span>
	} else {
		designerName = <Loader className="userTitleLoader" />
		userBio = <Loader className="userBioLoader" />
	}

	return <div id="designerInfo" className="flexColumn">
		{designerName}
		{userBio}
	</div>
	
}


const DesignerPage = (props) => {
	const userId = parseInt(props.match.params.userId, 10);
	const userProducts = useDesignerProducts(userId);
	const featuredProducts = useFeaturedProducts();

	const artWorkProducts = userProducts? userProducts.filter((v, i, a) => a.indexOf(v) === i).filter(p => p.artworkType === ARTWORK_TYPES.DIGITAL_ART.val): null;
	const photographProducts = userProducts? userProducts.filter(p => p.artworkType === ARTWORK_TYPES.PHOTOGRAPH.val): null;
	const productImages = artWorkProducts? artWorkProducts.map(p => p.previewImage): null;
	const designerInfo = userDesignerInfo(userId);
	const designerName = props.match.params.designerName;

	return (
		<SetoCanvasPage id="designerPage" title={designerName+" Artworks, Merchandise, T-Shirt, Hoodies and more | Seto Canvas"} 
						metaDescription={"Purchase "+designerName+" arts and many more at SetoCanvas.com"} >
			<DesignerHeader user={designerInfo} productImages={productImages} />
			<DesignerInfo user={designerInfo} />

			<Tabs id="designerMainTab" defaultSelectedIndex={0} key={designerName+"-maintab"} style={{minHeight: '300px'}}>
				<Tab key={designerName+"-shop"} value="shop" label="Shop">

					{userProducts && userProducts.length > 10 &&
						<ProductTabs products={userProducts} 
							ownerName={designerName} productViewMode="both" />
					}
					
					{(!userProducts || userProducts.length <= 10) &&
						<ProductList products={userProducts} viewProductTags={true} flattenProductImages={true}
							productViewMode="productOnly" emptyMsg="No Products Found" />
					}
				</Tab>

				{
					artWorkProducts && artWorkProducts.length > 0 &&
					<Tab key={designerName+"-artworks"} value="artworks" label="ArtWorks">
						<ProductList id="artworksList" products={artWorkProducts} viewProductTags={true}
							productViewMode="designOnly" emptyMsg="No Artworks Found" />

					</Tab>
				}
				
				{photographProducts && photographProducts.length > 0 &&
					<Tab key={designerName+"-photographs"} value="photographs" label="Photographs">
						<ProductList id="photographsList" products={photographProducts} viewProductTags={true}
							productViewMode="designOnly" emptyMsg="No Photographs Found"  />
					</Tab>
				}
			</Tabs>

			<Separator />
			<ProductList products={featuredProducts} showSlider={true} 
						title={"FEATURED ARTWORKS"} productViewMode="designOnly" />
			
		</SetoCanvasPage>
	);
}

export default DesignerPage;


// WEBPACK FOOTER //
// ./src/pages/DesignerPage.js